<template>
  <div>
    <HomeAwaitingRole v-if="showAwaitingRole" :email="userEmail" />

    <HomeMenu
      v-else-if="shouldShowCards"
      @open-music-library="handleMyMusicClick"
      @open-play-together="handlePlayTogetherClick"
      @open-quick-start="router.push('/quickstart')"
    />
  </div>
</template>

<script setup lang="ts">
import HomeAwaitingRole from '@/components/home/HomeAwaitingRole.vue'
import HomeMenu from '@/components/home/HomeMenu.vue'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useConvexQuery } from 'convex-vue'
import { api } from '../../convex/_generated/api'
import { useSupabaseAuth } from '../composables/useSupabaseAuth'

const router = useRouter()
const { user } = useSupabaseAuth()
const { data: appUser } = useConvexQuery(api.users.getCurrentUser, {})

const showAwaitingRole = computed(() => !!user.value && appUser.value?.role === 'none')
// Hide the cards layout while we're still resolving the signed-in user's role,
// so signed-in users with role 'none' never see the cards flash before the awaiting view.
const shouldShowCards = computed(() => !user.value || (appUser.value != null && appUser.value.role !== 'none'))

const userEmail = computed(() => appUser.value?.email ?? user.value?.email ?? '')

const handleMyMusicClick = () => {
  if (!user.value) {
    router.push('/auth')
  } else {
    router.push('/pieces')
  }
}

const handlePlayTogetherClick = () => {
  if (!user.value) {
    router.push('/auth?redirect=/classroom')
  } else {
    router.push('/classroom')
  }
}
</script>
